import i18n from '@/locales'

const urlStatusMap = {
  'default': {
    '1': 'status.default.open',
    '2': 'status.default.close'
  },
  '/experiment/examine/list': {
    '1': 'status.experiment.notStarted',
    '2': 'status.experiment.inProgress',
    '3': 'status.experiment.ended'
  },
  '/experiment/practice/list': {
    '1': 'status.practice.completed',
    '2': 'status.practice.incomplete'
  },
  '/student/experiment/practice/list': {
    '1': 'status.practice.completed',
    '2': 'status.practice.incomplete'
  },
  '/student/examine/list': {
    '1': 'status.experiment.notStarted',
    '2': 'status.experiment.inProgress',
    '3': 'status.experiment.ended'
  }
}

export function nameMap(arr, type = 'default') {
  arr.forEach(item => {
    if (item.updatedAt === '') item.updatedAt = '-'
    if (item.targetUrl === '') item.targetUrl = '-'
    if (item.trainingRoomName === '') item.trainingRoomName = '--'
    item.recommendName = item.recommend ? i18n.t('status.recommend.recommended') : i18n.t('status.recommend.notRecommended')
    const statusKey = urlStatusMap[type] === undefined ? urlStatusMap['default'][String(item.status)] : urlStatusMap[type][String(item.status)]
    item.statusName = i18n.t(statusKey)
    for (let key in item) {
      if (item[key] === null || item[key] === undefined || item[key] === '') {
        item[key] = '--'
      }
    }
  })
  return arr
}
